export const DUMMY_MENU_ACCESS = [
  { path: "/dashboard", isEnable: true },
  { path: "/product-management", isEnable: true },
  { path: "/user-list", isEnable: true },
  { path: "/customers-list", isEnable: true },
  { path: "QR Management", isEnable: true },
  { path: "/receipt", isEnable: true },
  { path: "/vouchers", isEnable: true },
  { path: "/kyc", isEnable: true },
  { path: "/my-campaign", isEnable: true },
  { path: "/orders", isEnable: true },
  { path: "/invoice", isEnable: false },
  { path: "/transactions-list", isEnable: true },
  { path: "/redemptions-list", isEnable: true },
  { path: "/settings", isEnable: true },
];

const isItemEnabled = (item, menuAccess) => {
  const key = item.path || item.name;
  const entry = menuAccess.find((access) => access.path === key);

  return entry ? entry.isEnable !== false : true;
};

// Only keeps top-level modules explicitly enabled in menuAccess.
export const filterMenuByStrictAccess = (menu, menuAccess) => {
  if (!menuAccess?.length) return menu;

  return menu
    .filter((item) => {
      const key = item.path || item.name;
      return menuAccess.some(
        (access) => access.path === key && access.isEnable !== false,
      );
    })
    .map((item) =>
      item.dropdown
        ? {
            ...item,
            dropdown: item.dropdown.filter((child) =>
              isItemEnabled(child, menuAccess),
            ),
          }
        : item,
    );
};

export const filterMenuByAccess = (menu, menuAccess) => {
  if (!menuAccess?.length) return menu;

  return menu
    .filter((item) => isItemEnabled(item, menuAccess))
    .map((item) =>
      item.dropdown
        ? {
            ...item,
            dropdown: item.dropdown.filter((child) =>
              isItemEnabled(child, menuAccess),
            ),
          }
        : item,
    );
};
